import Vue from "vue";
import store from "../../store"

export async function fetchMenu({ commit }, full_legal_number) {
  try {
    const { data } = await Vue.axios({
      url: `${process.env.VUE_APP_API_URL}/menus/api_menu_vue?view_as=${full_legal_number}`,
    });
    commit("setMenu", data);
  } catch (error) {
    commit("menuError", error.message);
  }
}

export async function fetchFooterMenu({ commit }) {
  try {
    const viewAs = localStorage.getItem("view_as");
    const url = viewAs
      ? `${process.env.VUE_APP_API_URL}/menus/api_footer_menu_vue?view_as=${viewAs}`
      : `${process.env.VUE_APP_API_URL}/menus/api_footer_menu_vue`;

    const { data } = await Vue.axios({
      url,
    });
    commit("setFooterMenu", data.footer_html);
  } catch (error) {
    commit("menuError", error.message);
  }
}